/* eslint-disable */
import { SVGProps } from "react";

const SvgTravel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34.687}
    height={48.045}
    fill="currentColor"
    viewBox="0 0 34.687 48.045"
    {...props}
  >
    <path
      data-name="Path 574"
      d="M21.171 36.045c2.592.888 4.88 1.453 8.168 2.463-1.263 15.961-16.356 9.622-8.168-2.463Zm13.474-14.662c-.17-4.792-1.014-11.079-7.738-10.094-3.152.823-5.481 4.284-6.576 10.256A28.68 28.68 0 0 0 20.79 32.2c.648 1.947.428 1.827 1.124 2.2 2.7.607 5.363 1.279 8.08 1.965 2.761-1.952 5.028-12.3 4.651-14.982Zm-20.749-.368a28.7 28.7 0 0 0 .458-10.656C13.26 4.387 10.931.925 7.778.1 1.055-.882.211 5.4.045 10.2c-.376 2.681 1.892 13.031 4.652 14.98 2.717-.685 5.385-1.357 8.081-1.965.691-.372.467-.253 1.119-2.2Zm-8.551 6.307c1.263 15.96 16.355 9.622 8.168-2.463-2.589.888-4.878 1.453-8.168 2.463Z"
    />
  </svg>
);

export default SvgTravel;
